import { queryClient } from '@/lib/react-query';
import { useUpdateMutationFactory, UseUpdateMutationProps } from '@/lib/react-query/update';
import { WorkOrder } from '@/types';
import { post } from '@/utils/api';
import { featureKeys, featurePath } from '.';

export type UpdateTaskDTO = { task: WorkOrder };

const uncompleteWorkOrder = ({ task }: UpdateTaskDTO) =>
  post<WorkOrder>(`${featurePath}/${task.task_id}/uncomplete`, {}, {});

export const useUncompleteWorkOrder = (options?: UseUpdateMutationProps<WorkOrder>) => {
  return useUpdateMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: uncompleteWorkOrder,
    onSuccess: (data) => {
      if (data?.taskable_type && data?.taskable_id) {
        queryClient.invalidateQueries({
          queryKey: [{ scope: data.taskable_type, entity: 'detail', id: data.taskable_id }],
        });
      }
    },
    ...options,
  });
};
